<div>
	<div mat-dialog-title>Cancel policy</div>
	<mat-divider></mat-divider>
	<div mat-dialog-content>
		Are you sure want to cancel
		<span class="fw-black">{{ data?.itemPolicyNo }}</span
		>? This action is not reversible.
	</div>

	<!--
	<form [formGroup]="formGroup">
		<div class="form-field mt-sm">
			<mat-form-field class="full-width">
				<mat-label>Cancellation reason</mat-label>
				<mat-select formControlName="CancelReason">
					<mat-option [value]="item" *ngFor="let item of rejectReasonList"
						>{{ item }}
					</mat-option>
				</mat-select>
				<mat-error>Cancellation reason is required</mat-error>
			</mat-form-field>

			<mat-form-field class="full-width">
				<mat-label>Remarks</mat-label>
				<input matInput formControlName="Remarks" />
				<mat-error>Remarks are required</mat-error>
			</mat-form-field>

			<mat-form-field class="full-width">
				<mat-label>Refund amount (optional)</mat-label>
				<input
					matInput
					formControlName="RefundAmount"
					autocomplete="off"
					mask="separator.2"
					thousandSeparator=","
					separatorLimit="99999999999999"
				/>
				<mat-error>Refund amount cannot be zero</mat-error>
			</mat-form-field>
		</div>
	</form>
	-->

	<div mat-dialog-actions>
		<button mat-button class="sm" [mat-dialog-close]="false">Cancel</button>
		<button
			mat-flat-button
			[mat-dialog-close]="true"
			color="warn"
			class="sm"
			(click)="onConfirm()"
		>
			Terminate policy
		</button>
	</div>
</div>
